import { produce } from "immer";
import { combineReducers } from "redux";
import { createReducer } from "typesafe-actions";
import { getRealtimeActions } from "./actions.js";
import { getSubscriptionKey } from "./utils.js";
class RealtimeReducerCreator {
  _realtimeActions;
  constructor() {
    this._realtimeActions = getRealtimeActions();
  }
  createReducer() {
    const subscriberReducers = createReducer({}).handleAction(this._realtimeActions.saveSubscriber, (state, action) => {
      const updatedState = produce(
        state,
        (draftState) => {
          const { entity, triggers, view } = action.payload;
          draftState[entity] = draftState[entity] ?? {};
          const subscriptionKeys = triggers?.map((trigger) => getSubscriptionKey(entity, trigger.type, trigger.args)) ?? [];
          subscriptionKeys?.forEach((key) => {
            if (!draftState[entity][key]) {
              draftState[entity] = {
                ...draftState[entity],
                [key]: []
              };
            }
            const subscriptions = draftState[entity][key];
            if (!subscriptions.includes(view)) {
              subscriptions.push(view);
            }
          });
        }
      );
      return updatedState;
    }).handleAction(this._realtimeActions.removeSubscriber, (state, action) => {
      const updatedState = produce(
        state,
        (draftState) => {
          const { entity, triggers, view } = action.payload;
          if (draftState[entity]) {
            const subscriptionKeys = triggers?.map((trigger) => getSubscriptionKey(entity, trigger.type, trigger.args)) ?? [];
            subscriptionKeys?.forEach((key) => {
              const subscriptions = draftState[entity][key];
              const index = subscriptions?.indexOf(view);
              if (index > -1) {
                subscriptions.splice(index, 1);
              }
            });
          }
        }
      );
      return updatedState;
    });
    const updatesReducer = createReducer({}).handleAction(this._realtimeActions.saveUpdatedViews, (state, action) => {
      const updatedState = produce(state, (draftState) => {
        const { entity, views } = action.payload;
        views.forEach((view) => {
          if (!draftState[view]?.entities?.length) {
            draftState[view] = { entities: [] };
          }
          if (!draftState[view].entities.includes(entity)) {
            draftState[view].entities.push(entity);
          }
        });
      });
      return updatedState;
    }).handleAction(this._realtimeActions.cleanUpdatedViews, () => ({}));
    return combineReducers({
      subscribers: subscriberReducers,
      updates: updatesReducer
    });
  }
}
export {
  RealtimeReducerCreator
};
//# sourceMappingURL=reducers.js.map
